import React from "react"
import PropTypes from "prop-types"
import Tooltip from "../atoms/Tooltip.atom"
import { generateRandomNumber } from "../../utils/numbers.utils"

const IconWithTooltip = ({
  iconClassName = "pi pi-info-circle",
  tooltipValue = "",
  position = undefined,
  onClick = null,
  style = {},
}) => {
  const id = generateRandomNumber()
  const defaultPosition = "bottom"
  return (
    <>
      <Tooltip
        target={`.icon-tooltip-${id}`}
        position={position || defaultPosition}
      />
      <i
        className={`${iconClassName} icon-tooltip-${id}`}
        data-pr-tooltip={tooltipValue}
        onClick={onClick}
        style={style}
      />
    </>
  )
}

IconWithTooltip.propTypes = {
  iconClassName: PropTypes.string,
  tooltipValue: PropTypes.string.isRequired,
  position: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
}

export default IconWithTooltip
